var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"booth-chat-btn",class:_vm.item.css_class,on:{"click":_vm.handleChat}},[_vm._v(" "+_vm._s(_vm.$t("chat.boothChat"))+" "),_c('img',{attrs:{"src":_vm.$images.mailWhite,"alt":"mail.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }